<template>
  <div class="image-controls">
    <ul>
      <li><span id="prev-image"><a class="bx-prev" @click="prev" title="previous"><ChevronIcon/></a></span></li>
      <li><a id="toggle-playback" @click="togglePlay" :title="!this.isPaused ? 'pause' : 'play'">
        <span v-show="!this.isPaused"><PauseIcon/>
</span>
        <span v-show="this.isPaused"><PlayIcon/>
</span>
      </a></li>
      <li><span id="next-image"><a class="bx-next" title="next" @click="next"><ChevronIcon/>
</a></span></li>
      <!--<li><span id=""><a class="bx-next" @click="toggleFullScreen()">
        <span v-show="!isFullScreen">Fullscreen</span>
        <span v-show="isFullScreen">Exit Fullscreen</span>
      </a></span></li>-->
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import eventHub from '@/components/image-slider/EventHub.js'
import ChevronIcon from '@/components/image-slider/ChevronIcon.vue';
import PlayIcon from '@/components/image-slider/PlayIcon.vue';
import PauseIcon from '@/components/image-slider/PauseIcon.vue';


export default {
    name: "slider-controls",
  components: { PauseIcon, PlayIcon, ChevronIcon },
    data() {
      return {
        wrapper: '',
        doc: ''
      }
    },
    computed: {
      ...mapState([
        'isFullScreen'
      ]),
      isPaused: {
        get(){
          return this.$store.state.slider.isPaused;
        },
        set(val){
          this.togglePlay(val);
        }
      },
    },
    methods: {
      ...mapMutations('slider', [
        'togglePlay',
      ]),
      next() {
        eventHub.$emit('next');
        // if(this.debug) console.log('clicked next');
      },
      prev() {
        eventHub.$emit('prev');
        // if(this.debug) console.log('clicked prev');
      },
      toggleFullScreen(){
        this.$emit('full-screen');
      }
    },
    mounted() {
      // eventHub.$on('toggle-fullscreen', () => {
      //   this.isFullScreen = !this.isFullScreen;
      // });
      // eventHub.$on('pause', () => {
      //   this.isPaused = true;
      // });
      // eventHub.$on('play', () => {
      //   this.isPaused = false;
      // });
    },

  }

</script>

